var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Grid", {
        attrs: {
          service: _vm.service,
          route_name: "user_access_logs",
          order_column: "login_at",
          direction: "desc",
          hide_actions: "true",
          css_formats: {
            status: function(status, model) {
              if (status === "success") {
                return "badge badge-glow badge-success"
              } else if (status === "failed") {
                return "badge badge-glow badge-danger"
              } else if (status === "unauthorized") {
                return "badge badge-glow badge-warning"
              }
              return ""
            }
          },
          column_formats: {
            status: function(val) {
              if (val === "success") {
                return this$1.$t("last_access.status.success")
              } else if (val === "failed") {
                return this$1.$t("last_access.status.failed")
              } else if (val === "unauthorized") {
                return this$1.$t("last_access.status.unauthorized")
              }
              return val || ""
            }
          }
        },
        scopedSlots: _vm._u([
          {
            key: "gridData",
            fn: function(props) {
              return _vm._l(props.data, function(tr, indextr) {
                return _c(
                  "vs-tr",
                  { key: indextr, attrs: { data: tr } },
                  [
                    _c("vs-td", { key: "id" }, [
                      _c("div", [_vm._v(_vm._s(tr.id))])
                    ]),
                    _c("vs-td", { key: "status" }, [
                      _c("div", { class: _vm.getStatusCss(tr.status) }, [
                        _vm._v(" " + _vm._s(_vm.getStatusText(tr.status)) + " ")
                      ])
                    ]),
                    _c("vs-td", { key: "email" }, [
                      _c("div", [_vm._v(_vm._s(tr.email || ""))])
                    ]),
                    _c("vs-td", { key: "user_name" }, [
                      _c("div", [
                        _vm._v(_vm._s((tr.user && tr.user.name) || ""))
                      ])
                    ]),
                    _c("vs-td", { key: "ip_address" }, [
                      _c("div", [_vm._v(_vm._s(tr.ip_address || ""))])
                    ]),
                    _c("vs-td", { key: "device_type" }, [
                      _c("div", [_vm._v(_vm._s(tr.device_type || ""))])
                    ]),
                    _c("vs-td", { key: "browser" }, [
                      _c("div", [_vm._v(_vm._s(tr.browser || ""))])
                    ]),
                    _c("vs-td", { key: "platform" }, [
                      _c("div", [_vm._v(_vm._s(tr.platform || ""))])
                    ]),
                    _c("vs-td", { key: "login_at_formatted" }, [
                      _c("div", [_vm._v(_vm._s(tr.login_at_formatted || ""))])
                    ]),
                    _c("vs-td", { key: "logout_at_formatted" }, [
                      _c("div", [_vm._v(_vm._s(tr.logout_at_formatted || ""))])
                    ])
                  ],
                  1
                )
              })
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }